module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/akt-eeb87eb13f2c1dcf4213795fbe79dfbd.png";